import { render, staticRenderFns } from "./ChoosePromo.vue?vue&type=template&id=00af43ce"
import script from "./ChoosePromo.vue?vue&type=script&lang=js"
export * from "./ChoosePromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports